export default {
  ppt: {
    redirectButtonNavBarUrl: "https://ppt.ch/en/asset-management/",
    redirectButtonNavBarText: "Voltar ao sítio principal",
  },
};
